import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomButton from '../button/button';
import CustomLink from '../link/link';

export default function WbNavbar() {
  const location = useLocation();
  const [activePath, setActivePath] = useState('/');
  const [isMounted, setIsMounted] = useState(false);

  const handleClick = (paths) => {
    window.open(`https://order.wheatbakes.com/onlineorder/`, "_blank");
  };

  useEffect(() => {
    setIsMounted(true);
    setActivePath(location.pathname);
  }, [location]);

  if (!isMounted) return null;

  const isActive = (path) => activePath === path ? 'wb-active' : '';

  return (
    <>
    <div className="scrolling-text-container" >
      <div className="scrolling-text">
        🚀 For outstation orders, WhatsApp us to +91 7904309386 
      </div>
    </div>
    <Navbar expand="lg" className="wb-bg-primary wb-nav">
      <Container>
        {/* Logo on left */}
        <Navbar.Brand href="#">
          <img
            src={"/images/Wheatbakes-Logo.svg"}
            width={"160px"}
            alt={"Wheat Bakes"}
          />
        </Navbar.Brand>

        {/* Mobile/Tablet toggle button */}
        <Navbar.Toggle aria-controls="offcanvasNavbar" />

        {/* Offcanvas menu that slides from right */}
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end" // makes it slide from right
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel">
                <img
                    src={"/images/wheat-bakes-light-logo.png"}
                    width={"160px"}
                    alt={"Wheat Bakes"}
                />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="ms-auto wheatbakes-navbar">
              <CustomLink text={"Home"} type={"nav"} path={"home"} activeCss={isActive("/home")} />
              <CustomLink text={"About Us"} type={"nav"} path={"about-us"} activeCss={isActive("/about-us")} />
              <CustomLink text={"Menu"} type={"nav"} path={"menu"} activeCss={isActive("/menu")} />
              {/* <CustomLink text={"Gallery"} type={"nav"} path={"gallery"} activeCss={isActive("/gallery")} /> */}
              <CustomLink text={"Blogs"} type={"nav"} path={"blogs"} activeCss={isActive("/blogs")} />
              <CustomLink text={"Contact"} type={"nav"} path={"contact"} activeCss={isActive("/contact")} />
              <CustomLink text={"FAQ"} type={"nav"} path={"faq"} activeCss={isActive("/faq")} />
              <CustomLink text={"Bulk Orders"} type={"nav"} path={"bulkorders"} activeCss={isActive("/bulkorders")} />
              <CustomButton buttonType={2} text={"Order Now"} size={"md"} path={"onlineorder"} onClick={handleClick} require={true} />
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
    </>
  );
}
